import React from 'react';
import IconButton from 'components/common/IconButton';
import FalconCardHeader from 'components/common/FalconCardHeader';
import PropTypes from 'prop-types';

const ProspectCustomerTableHeader = ({
  toggelModal,
  toggelFilter,
  isFromManagerPage
}) => {

  return (
    <div>
      <FalconCardHeader
        title="Add prospect"
        light
        titleTag="h6"
        endEl={
          <div
            id="orders-actions"
            className="d-flex align-items-center justify-content-between"
          >
            {!isFromManagerPage && (
              <IconButton
                variant="falcon-default"
                size="md"
                icon="plus"
                transform="shrink-2"
                onClick={toggelModal}
                className="ms-2"
              >
                <span className="d-none d-sm-inline-block ms-1">New</span>
              </IconButton>
            )}
            {isFromManagerPage && (
              <div className="d-flex align-items-center ms-2">
                <IconButton
                  variant="falcon-default"
                  size="md"
                  icon="filter"
                  transform="shrink-3"
                  className="mx-2"
                  onClick={toggelFilter}
                >
                  <span className="d-none d-sm-inline-block ms-1">Filter</span>
                </IconButton>
              </div>
            )}
          </div>
        }
      />
    </div>
  );
};

ProspectCustomerTableHeader.propTypes = {
  toggelFilter: PropTypes.func,
  handleSearch: PropTypes.func,
  toggelModal: PropTypes.func,
  isFromManagerPage: PropTypes.bool
};

export default ProspectCustomerTableHeader;
